module.exports = __webpack_public_path__ + "static/media/icon_timeline.8b1d8c4f.svg";